module.exports = __webpack_public_path__ + "static/media/view.1fe25fdd.svg";